import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { compact } from 'lodash-es';
import { MultiSelectFilterPicker } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const GetActivityLogFiltersTID = (parentTestId)=>getTestIds(parentTestId);
export const ActivityLogFilters = (param)=>{
    let { appliedSelection, onApply, isClient = false, testId } = param;
    const { t } = useLocaleKeys();
    const texts = t.activityLog.filters;
    const hideIntegrations = isClient;
    const options = useMemo(()=>compact([
            {
                label: texts.buckets.invoices(),
                value: 'Invoices'
            },
            {
                label: texts.buckets.payment(),
                value: 'Payment'
            },
            {
                label: texts.buckets.amendments(),
                value: 'Amendments'
            },
            !hideIntegrations && {
                label: texts.buckets.integrations(),
                value: 'Integrations'
            },
            {
                label: texts.buckets.proposalLifecycle(),
                value: 'ProposalLifecycle'
            }
        ]), [
        texts.buckets,
        hideIntegrations
    ]);
    const selectedValues = useMemo(()=>options.filter((option)=>appliedSelection.has(option.value)).map((option)=>option.value), [
        options,
        appliedSelection
    ]);
    return /*#__PURE__*/ _jsx(MultiSelectFilterPicker, {
        label: texts.label(),
        options: options,
        value: selectedValues,
        onChange: (values)=>onApply(new Set(values)),
        selectAllLabel: texts.selectAll(),
        bi: {
            name: 'activity_log_filters_pill'
        },
        testId: testId
    });
};
